import { Pattern } from 'ts-pattern'
import { z } from 'zod'

import { is } from '~/core/utils/is'

export const P = {
  ...Pattern,
  safeInt: Pattern.when(is(z.number().int().safe())),
  valued: Pattern.not(Pattern.nullish),
}
